import type { AgentOtcGetHistoryParams } from '../api'
import { api } from '../api'

export const getAgentOtcGetHistory = async (data: AgentOtcGetHistoryParams) => {
  return await api.v1.agentOtcGetHistory(data)
}

export default {
  getAgentOtcGetHistory,
}
